import { API_BASE_URLS } from './apiBaseUrls';

export const defaults = {
  apiBaseUrl: API_BASE_URLS['us'],
  serviceWorkerQueryKey: 'notifications',
  serviceWorkerUrl: '/service-worker.js?sdkVersion=3.0.0',
} as const;
